module.exports = __webpack_public_path__ + "static/media/spectranet.0833efd6.png";